import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import Tooltip from 'rc-tooltip';
import { bindActionCreators, Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as actionsJourney from '../../actions/journey1';
import * as actionsCheckout from '../../actions/checkout';
import * as _actionsBasket from '../../actions/basket';
import * as actionsSujet from '../../actions/sujet';
import { RootState } from '../../reducers';
import { Button, EButtonType } from '@repo/apg-ui';
import './OrderCompleted.scss';
import * as actions from '../../actions/index';
import SpinnerV2 from '../../components/SpinnerV2';
import styles from '../../components/CampaignRow/CampaignRow.module.scss';
import CampaignRow from '../../components/CampaignRow';
import Spinner from '../../components/Spinner';
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';
import { isProd, isStage } from '../../constants/config';
import classNames from 'classnames';
import { usePrevious, useUpdateEffect } from 'react-use';
import { getParameterByName } from '../../utils/toSearchParams';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  actionsJourney: any;
  actionsCheckout: any;
  actionsBasket: any;
  router: any;
  intl: any;
  journey2?: boolean;
  loading: boolean;
  locales: any;
  history: any;
  possibleBookingDates: any;
  postProposals: any;
  proposals: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
  match: any;
  actionsSujet: any;
  keycloakReady: boolean;
  dispatch: any;
}

const OrderCompletedOld = (props: Props) => {
  const prevKeycloakReady = usePrevious(props.keycloakReady);
  const [isOfferte, setIsOfferte] = useState(false);
  const [campaignId, setCampaignId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('step10');

    if (props.router.location.state?.referrer.includes('checkout/accept') && props.router.location.search) {
      props.actionsCheckout.getPostfinanceAccept(props.router.location.search);
    }

    try {
      const payload = {
        basket: props.journey2 ? props.userDataEC.basketInfo.basket : props.userDataEC.chosenProposal.basket,
        basketreference: props.journey2
          ? props.userDataEC.basketInfo.basketreference || null
          : props.userDataEC.chosenProposal.basketreference,
        countgroup: 'format',
      };

      props.actionsBasket.fetchBasketInfo(payload).then((res) => {
        setIsOfferte(res.category === 2 || res.category === 3);
        setCampaignId(getParameterByName('campaignId', props.history?.location?.search) || null);
      });

      props.actionsJourney.getUserInfo();
      getBookBasketInfo();
      fetchCampaigns();

      props.actionsCheckout.fetchPaymentMethods({
        basket: props.journey2 ? props.userDataEC.basketInfo.basket : props.userDataEC.chosenProposal.basket,
      });
    } catch (err) {
      console.error('FE error', err);
    }

    return () => {
      document.body.classList.remove('step10');
    };
  }, []);

  const fetchCampaigns = () => {
    let payload = {
      owner: (window as any).keycloak.tokenParsed['gepard-nr'],
    };

    props.actionsSujet.getCampaigns(payload);
  };

  useUpdateEffect(() => {
    if (props.keycloakReady && props.keycloakReady !== prevKeycloakReady) {
      fetchCampaigns();
    }
  }, [props.keycloakReady]);

  const getBookBasketInfo = () => {
    const {
      journey2,
      userDataEC: { basketInfo, chosenProposal },
      actionsJourney,
    } = props;

    actionsJourney
      .getBasketState({
        basket: journey2 ? basketInfo.basket : chosenProposal.basket,
        moreinfo: 3,
      })
      .catch((err) => console.error(err));
  };

  const renderUnavailableProducts = (product: any) => {
    if (!isEmpty(product)) {
      const { name, mediacount, duration, startdate } = product;

      return (
        <div className={'w-100 p-24 fw-bold'} key={name + mediacount + startdate}>
          <FormattedMessage
            id='ec.confirmation.unavailableProduct'
            defaultMessage='- {name}{mediacount}, {duration} Tage. ab {startdate}'
            values={{
              name,
              duration,
              mediacount:
                mediacount && mediacount > 1
                  ? ` (${mediacount} ${props.intl.formatMessage({
                      id: 'ec.confirmation.flachen',
                      defaultMessage: 'Flächen',
                    })})`
                  : '',
              startdate: !!startdate && format(parseISO(startdate), 'dd.MM.yy', { locale: de }),
            }}
          />
        </div>
      );
    }

    return null;
  };

  const renderFailInformationCompany = () => {
    if (props.userDataEC && props.userDataEC.basketInfo) {
      const {
        userDataEC: {
          basketInfo: { state, information },
        },
      } = props;

      if (!!state && state === 3 && !isEmpty(information)) {
        const newBaskets = information.newbaskets;
        const length = newBaskets.length;
        const productNotBooked = information.productnotbooked;
        const productsByUrn = props.userDataEC.basketProducts.productsByUrn;
        const label = props.intl.formatMessage({
          id: 'ec.confirmation.downloadLink',
          defaultMessage: 'Download Warenkorb',
        });

        return (
          <>
            <div className={'w-100 p-24 mb-4 unavailable-products-wrapper'}>
              <h4 className={'w-100 p-24 mb-4 fw-bold red-text unavailable-products-wrapper__title'}>
                <FormattedMessage
                  id='ec.confirmation.unavailableProductsTitle'
                  defaultMessage='Achtung: Folgende Produkte konnten nicht gebucht werden:'
                />
              </h4>

              <div>
                {productNotBooked &&
                  productNotBooked.length > 0 &&
                  productNotBooked.flat().map((product) =>
                    renderUnavailableProducts({
                      ...productsByUrn[product.producturn],
                      ...product,
                    }),
                  )}
              </div>
            </div>

            <p className='w-100 p-24 fw-bold sub-title'>
              <FormattedMessage id='ec.confirmation.whatCanToDo' defaultMessage='Was können Sie tun?' />
            </p>

            <ul className={'list-what-do mb-48 sub-title'}>
              <li>
                <FormattedMessage
                  id='ec.confirmation.downloadProducts'
                  defaultMessage='Laden Sie sich hier die nicht gebuchten Produkte via CSV-Datei herunter.'
                />{' '}
                {newBaskets &&
                  length > 0 &&
                  newBaskets.map(({ downloadlink }, idx) => {
                    return (
                      <>
                        <a
                          className='red-text text-underline'
                          rel='noopener noreferrer'
                          href={downloadlink}
                          target='_blank'
                        >
                          {idx === 0 ? label : label.toLowerCase()}
                        </a>
                        {length !== 1 && length - 1 === idx ? '' : ', '}
                      </>
                    );
                  })}
              </li>
              <li>
                <FormattedMessage
                  id='ec.confirmation.bookOnline'
                  defaultMessage='Versuchen Sie diese entsprechend nochmals selber online einzubuchen oder'
                />
              </li>
              <li>
                <FormattedMessage
                  id='ec.confirmation.sendEmail'
                  defaultMessage='senden Sie uns die CSV-Datei via Mail an <a>Mailaddressse</a> mit der Bitte die Produkte für Sie einzubuchen.'
                  values={{
                    a: (child) => (
                      <a
                        className='red-text'
                        href={`mailto:${props.intl.formatMessage({
                          id: 'ec.confirmation.sendEmailLink',
                          defaultMessage: 'servicedesk@apgsga.ch',
                        })}`}
                      >
                        {child}
                      </a>
                    ),
                  }}
                />
              </li>
            </ul>
          </>
        );
      }
    }

    return null;
  };

  const { userDataEC, intl } = props;

  return userDataEC ? (
    <div className='OrderCompleted row'>
      <div className='col bg-white me-20'>
        <div className='col-12'>
          <h3 className='w-100 p-24 mt-24 mb-4 fw-bold title-journey'>
            <FormattedMessage id='ec.confirmation.thankyou' defaultMessage='Herzlichen Dank für Ihren Auftrag!' />
          </h3>

          <p className='w-100 p-24 mb-4 sub-title'>
            {userDataEC.basketInfo && (
              <FormattedMessage
                id='ec.confirmation.campaign'
                defaultMessage='Ihre Buchung wurde uns mit der <b>Kampagnen-Nr. {campaignNr}</b> übermittelt.'
                values={{
                  b: (child) => <b>{child}</b>,
                  campaignNr: String(userDataEC.basketInfo.ordernumber || userDataEC.basketInfo.basket).replace(
                    /,/gi,
                    ', ',
                  ),
                }}
              />
            )}
          </p>
          <p className='w-100 p-24 mb-4 sub-title'>
            {userDataEC.basketInfo && !isOfferte && (
              <FormattedMessage
                id='ec.confirmation.campaign'
                defaultMessage='Ihre Buchung wurde uns mit der <b>Kampagnen-Nr. {campaignNr}</b> übermittelt.'
                values={{
                  b: (child) => <b>{child}</b>,
                  campaignNr: String(userDataEC.basketInfo.ordernumber || userDataEC.basketInfo.basket).replace(
                    /,/gi,
                    ', ',
                  ),
                }}
              />
            )}
            {userDataEC.basketInfo && isOfferte && userDataEC.basketInfo.category === 2 && (
              <FormattedMessage
                id='ec.confirmation.campaignRichtofferte'
                defaultMessage='Die gewünschte Richtofferte wurde Ihnen via E-Mail übermittelt. Eine Reservation oder Buchung der Flächen hat nicht stattgefunden.'
              />
            )}
            {userDataEC.basketInfo && isOfferte && userDataEC.basketInfo.category === 3 && (
              <FormattedMessage
                id='ec.confirmation.campaignOfferte'
                defaultMessage='Ihre Offerte wurde uns mit der <b>Nr. {campaignNr}</b> übermittelt und die Flächen werden für Sie für {reserveddays} Tage reserviert.'
                values={{
                  b: (child) => <b>{child}</b>,
                  campaignNr: campaignId,
                  reserveddays: userDataEC.basketInfo.reserveddays,
                }}
              />
            )}
          </p>

          <p className='w-100 p-24 mb-4 sub-title'>
            {!isOfferte && (
              <FormattedMessage
                id='ec.confirmation.link'
                defaultMessage='Alle Angaben zu Ihrem Auftrag finden Sie in <a>myAPG</a> und in Ihrem E-Mail Postfach.'
                values={{
                  a: (child) => (
                    <a
                      className='red-text'
                      rel='noopener noreferrer'
                      href={
                        isProd
                          ? intl.formatMessage({
                              id: 'ec.dashboardService.profileProdLink',
                              defaultMessage: 'https://my.apgsga.ch/ui/profile-form',
                            })
                          : isStage
                            ? intl.formatMessage({
                                id: 'ec.dashboardService.profileStageLink',
                                defaultMessage: 'https://my-t1.apgsga.ch/ui/profile-form',
                              })
                            : intl.formatMessage({
                                id: 'ec.dashboardService.profileDevLink',
                                defaultMessage: 'https://my-t1.apgsga.ch/ui/profile-form',
                              })
                      }
                      target='_blank'
                    >
                      {child}
                    </a>
                  ),
                }}
              />
            )}
            {isOfferte && userDataEC.basketInfo && userDataEC.basketInfo.category === 2 && (
              <FormattedMessage
                id='ec.confirmation.linkRichtofferte'
                defaultMessage='Alle Angaben zu Ihrer Richtofferte finden Sie zudem auch im Dashboard unter "Gespeicherte Warenkörbe".'
              />
            )}
            {isOfferte && userDataEC.basketInfo && userDataEC.basketInfo.category === 3 && (
              <FormattedMessage
                id='ec.confirmation.linkOfferte'
                defaultMessage='Alle Angaben zu Ihrer Anfrage finden Sie im Dashboard unter "Übersicht Offerten" und in Ihrem E-Mail Postfach.'
              />
            )}
          </p>

          <p className='w-100 p-24 mb-4 sub-title'>
            {
              <FormattedMessage
                id='ec.confirmation.lookingforward'
                defaultMessage='Wir freuen uns auf Ihre Werbekampagne und führen Ihren Auftrag mit grösster Sorgfalt aus.'
              />
            }
          </p>

          {renderFailInformationCompany()}

          <p className='w-100 p-24 mb-4 sub-title'>
            <FormattedMessage
              id='ec.confirmation.questions'
              defaultMessage='Haben Sie noch Fragen? Wir sind gerne für Sie da.'
            />
          </p>

          <div className='mb-48'>
            <Button
              buttonType={EButtonType.PillMedium}
              href={
                isProd
                  ? intl.formatMessage({
                      id: 'ec.dashboardService.boxBookingProdLink',
                      defaultMessage: 'https://apgsga.ch/de/aussenwerbung/plakate-online-buchen/',
                    })
                  : isStage
                    ? intl.formatMessage({
                        id: 'ec.dashboardService.boxBookingStageLink',
                        defaultMessage:
                          'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
                      })
                    : intl.formatMessage({
                        id: 'ec.dashboardService.boxBookingDevLink',
                        defaultMessage:
                          'https://apg-website-2021-private-cloud-stage.apg.divio.cloud/de/aussenwerbung/plakate-online-buchen/',
                      })
              }
            >
              <FormattedMessage id='ec.confirmation.weitereKampagneBuchen' defaultMessage='Weitere Kampagne buchen' />
            </Button>
          </div>
        </div>
      </div>

      <div className='col-12 bg-white'>
        <div className='col-12 d-flex justify-content-between table-header'>
          <p className='fw-bold mb-3 mt-24'>
            {isOfferte ? (
              <FormattedMessage id='as.sujet.allKampagnen' defaultMessage='Alle Kampagnen' />
            ) : (
              <FormattedMessage id='as.sujet.gebuchteKampagnen' defaultMessage='Gebuchte Kampagnen' />
            )}
          </p>

          <Button onClick={() => navigate({ search: `?modalContent=legende` })}>
            <div className='legend d-flex'>
              <div>
                <Tooltip
                  overlayClassName={'rc-tooltip-bg-white'}
                  placement={'right'}
                  overlay={
                    <b>
                      <FormattedMessage id='ec.confirmation.legendTooltip' defaultMessage='Legend tooltip' />
                    </b>
                  }
                >
                  <InfoIcon className='me-3' />
                </Tooltip>
              </div>

              <p className='red-text'>
                <FormattedMessage id='ec.confirmation.legend' defaultMessage='Legende' />
              </p>
            </div>
          </Button>
        </div>

        <div className='d-flex flex-column mt-4'>
          <div className={`d-flex table-header ${styles.productTitle}`}>
            <div className={styles.productRowCampaignColumn}>
              <div className='d-flex flex-column'>
                <p className='small-text'>
                  <FormattedMessage id='ec.confirmation.table.details' defaultMessage='Details' />
                </p>
                <p className='fw-bold'>
                  <FormattedMessage id='ec.confirmation.table.campaign' defaultMessage='Kampagne' />
                </p>
              </div>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.sujet' defaultMessage='Sujet' />
              </p>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.period' defaultMessage='Zeitraum' />
              </p>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.advertisingForm' defaultMessage='Werbeform' />
              </p>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <div className='d-flex flex-column'>
                <p className='small-text'>
                  <FormattedMessage id='ec.confirmation.table.services' defaultMessage='Services' />
                </p>
                <p className='fw-bold'>
                  <FormattedMessage id='ec.confirmation.table.design' defaultMessage='Gestaltung' />
                </p>
              </div>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.print' defaultMessage='Druck' />
              </p>
            </div>

            <div className={styles.productRowCampaignColumn}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.spotUpload' defaultMessage='Spot upload' />
              </p>
            </div>

            <div className={classNames(styles.productRowCampaignColumn)}>
              <p className='fw-bold'>
                <FormattedMessage id='ec.confirmation.table.copyCampaign' defaultMessage='Kampagne nochmals buchen' />
              </p>
            </div>

            <div className={styles.productRowCampaignColumn} />
          </div>

          {userDataEC.campaigns ? (
            userDataEC.campaigns.slice(0, 3).map((campaign, index) => {
              return (
                <CampaignRow
                  key={`${campaign.number}`}
                  index={index}
                  orderCompletedPage
                  product={campaign}
                  moreContent={campaign.number}
                />
              );
            })
          ) : (
            <Spinner relative />
          )}

          <div className='d-flex align-items-center justify-content-center my-48'>
            <Button className='ms-0' onClick={() => navigate('/dashboard')} buttonType={EButtonType.PillMedium}>
              {!isOfferte ? (
                <FormattedMessage
                  id='ec.components.buttons.allCampagne'
                  defaultMessage='Alle gebuchten Kampagnen anzeigen'
                />
              ) : (
                <FormattedMessage
                  id='ec.components.buttons.allCampagneOfferte'
                  defaultMessage='AlleKampagnen anzeigen'
                />
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <SpinnerV2 />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
    router: state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
    actionsCheckout: bindActionCreators(actionsCheckout as any, dispatch),
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderCompletedOld)));
